import { unique } from "../../lib/utils"

/**
 * Hides or shows an offer data item based on whether the offer is hidden, the register is hidden, or the sign is hidden.
 * #offers #showHideOffer
 * @param {object} offerData - an array of offer data objects
 * @param {object} allOffers - an array of all offers
 * @returns {object} an array of offer data objects with the `hide` property added
 */
export const HiddenOfferData = ({offerData=[], allOffers=[]}) => {
    //#showHideOffer
    //console.log("lskdjhcl<",allOffers, offerData)
    const hiddenOfferData = !Array.isArray(offerData) ? [] : offerData?.map?.((item)=>{
      const offer = !Array.isArray(allOffers) ? undefined : allOffers?.find?.(x=>x?.site?._ref == item?.siteId)
/*       const registerTemplateId = () => 
        { 
          //if(item?.isSign) return "signs"
          return item?.registerTemplateId 
        }

        const existingRegistersIds = unique("registerId", offer?.offerFields)?.map?.((x)=>x?.registerId)  */
     
      const isSign = item?.isSign
      const isSignRegisterHidden = !Array.isArray(offer?.hideRegisters) ? false : offer?.hideRegisters?.some?.(x=>x == "weduwheiudghyegwuyjke88363ghdloiejdf87")
      const isRegisterHidden = !Array.isArray(offer?.hideRegisters) ? false : offer?.hideRegisters?.some?.(x=>x == item?.registerId)

      if(isSign && isSignRegisterHidden) return {...item, hide: true}
      if(isSign && !isSignRegisterHidden && !item?.hide) return {...item, hide: false}
      if(isRegisterHidden) { 
        return {...item, hide: true}
      }
      return item
    })
    return hiddenOfferData

}

/**
 * Hides or shows an offer data item based on whether the offer is hidden, the register is hidden, or the sign is hidden.
 * #showHideOrder #unused
 * @param {object} offerData - an array of offer data objects
 * @param {object} allOffers - an array of all offers
 * @returns {object} an array of offer data objects with the `hide` property added
 */
export const OrderedOfferData = ({offerData=[], allOffers=[]}) => {
    //#showHideOrder
    //console.log("lskdjhcl<",allOffers, offerData)
    const hiddenOfferData = !Array.isArray(offerData) ? [] : offerData?.map?.((item)=>{
      const offer = !Array.isArray(allOffers) ? undefined : allOffers?.find?.(x=>x?.site?._ref == item?.siteId)
/*       const registerTemplateId = () => 
        { 
          //if(item?.isSign) return "signs"
          return item?.registerTemplateId 
        }

        const existingRegistersIds = unique("registerId", offer?.offerFields)?.map?.((x)=>x?.registerId)  */
     
      const isSign = item?.isSign
      const isSignRegisterHidden = !Array.isArray(offer?.hideRegisters) ? false : offer?.hideRegisters?.some?.(x=>x == "weduwheiudghyegwuyjke88363ghdloiejdf87")
      const isRegisterHidden = !Array.isArray(offer?.hideRegisters) ? false : offer?.hideRegisters?.some?.(x=>x == item?.registerId)

      if(isSign && isSignRegisterHidden) return {...item, hide: true}
      if(isSign && !isSignRegisterHidden && !item?.hide) return {...item, hide: false}
      if(isRegisterHidden) { 
        return {...item, hide: true}
      }
      return item
    })
    return hiddenOfferData

}